import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../Home.css";
import CountUp from "react-countup";
import DonationForm from "./DonationForm";
import EligibilitySection from "./EligibilitySection";
import SearchBar from "./Searchbar";
import ContactSection from "./ContactSection";
import Reviews from "./Reviews";
import BenefitsSection from "./BenefitsSection";
import BloodDonationSlider from "./BloodDonationSlider";
import Nav from "../Navbar-footer/Nav";


const statsData = [
  {
    value: 12000000,
    suffix: "",
    label: "Units of blood needed in India yearly",
  },
  { value: 32000, suffix: "", label: "Units of blood used daily in India" },
  { value: 3, label: "Lives saved per blood donation" },
  { value: 33, suffix: "%", label: "Indians eligible to donate blood" },
];

const benefits = [
  {
    icon: "❤️",
    title: "Save Lives",
    description:
      "A single donation can help save up to three lives. Be a hero today.",
  },
  {
    icon: "💪",
    title: "Health Benefits",
    description: "Reduces harmful iron stores, improves cardiovascular health.",
  },
  {
    icon: "🔄",
    title: "Free Health Check",
    description:
      "Get free mini check-ups including pulse, BP, hemoglobin level.",
  },
  {
    icon: "😊",
    title: "Feel Good",
    description:
      "Experience the joy of helping others in need. It’s fulfilling!",
  },
];


// const bloodCompatibility = {
//   "A+": { receive: ["O+", "O-", "A+", "A-"], donate: ["A+", "AB+"] },
//   "O+": { receive: ["O+", "O-"], donate: ["A+", "B+", "O+", "AB+"] },
//   "B+": { receive: ["O+", "O-", "B+", "B-"], donate: ["B+", "AB+"] },
//   "AB+": {
//     receive: ["A+", "B+", "O+", "AB+", "A-", "B-", "O-", "AB-"],
//     donate: ["AB+"],
//   },
//   "A-": { receive: ["O-", "A-"], donate: ["A+", "A-", "AB+", "AB-"] },
//   "O-": {
//     receive: ["O-"],
//     donate: ["A+", "B+", "O+", "AB+", "A-", "B-", "O-", "AB-"],
//   },
//   "B-": { receive: ["O-", "B-"], donate: ["B+", "B-", "AB+", "AB-"] },
//   "AB-": { receive: ["A-", "B-", "O-", "AB-"], donate: ["AB+", "AB-"] },
// };
const Hero = () => {
  const navigate = useNavigate();
  // const [activeTab, setActiveTab] = useState("before");
  const [showForm, setShowForm] = useState(false);
  const formRef = useRef(null);
  // const [selectedGroup, setSelectedGroup] = useState("A+");
  // const selected = bloodCompatibility[selectedGroup];

  // const scrollToRegister = () => {
  //   const element = document.getElementById("save-lives-section");
  //   if (element) {
  //     element.scrollIntoView({ behavior: "smooth" });
  //   }
  // };

  const handleToggleForm = () => {
    setShowForm((prev) => {
      const next = !prev;

      // If opening the form
      if (!prev) {
        // Wait for form to render, then scroll
        setTimeout(() => {
          window.scrollTo({
            top: formRef.current.offsetTop - 50, // 50px above the form
            behavior: "smooth",
          });
        }, 100);
      }

      return next;
    });
  };
  return (
    
    <>
     <Nav />
      <section className="hero-wrapper">
        <div className="hero">
          <div className="hero-content">
            {/* Left Content */}
            <div className="hero-left">
              <span className="welcome-line">
                Welcome to Sarv Sahayata Sangathan
              </span>
              <h1>Give the Gift of Life</h1>
              <p>
                Your donation can save up to three lives.
                <br /> Join our community of donors and make a difference today.
              </p>
              <div className="hero-actions">
                <button
                  className="register-btn"
                  onClick={() =>
                    document
                      .getElementById("save-lives-section")
                      ?.scrollIntoView({ behavior: "smooth" })
                  }
                >
                 Join Blood Network
                </button>
                <button className="about-us" onClick={() => navigate("/about")}>
                  About Us
                </button>
              </div>
            </div>

            {/* Right Image */}
            <div className="hero-right">
              <img src="../../assets/bloodlogo.png" alt="Blood donation" />
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="hero-stats">
          {statsData.map((stat, index) => (
            <div className="stat-box" key={index}>
              <h2>
                <CountUp
                  end={stat.value}
                  duration={3}
                  separator=","
                  suffix={stat.suffix || ""}
                />
              </h2>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
      </section>
      <SearchBar />
      <BenefitsSection />
      <BloodDonationSlider />

      {/* {why donate section} */}
      <section className="why-donate-section">
        <h2 className="section-title">Why Donate Blood?</h2>
        <p className="section-subtitle">
          Blood donation is a simple process that makes a big difference in
          people’s lives.
        </p>
        <div className="benefits-container">
          {benefits.map((benefit, index) => (
            <div className="benefit-card" key={index}>
              <div className="icon">{benefit.icon}</div>
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </section>
      
      




      {/* // {form section} */}

      {!showForm && (
        <section className="save-lives-section" id="save-lives-section">
          <h2>Ready to Save Lives?</h2>
          <p>
            Join our community of donors today. The process is quick, easy, and
            your contribution makes a real difference.
          </p>

          <div className="save-lives-actions">
            <button className="register-btn" onClick={handleToggleForm}>
              Join Blood Network
            </button>
            {/* <input
              type="text"
              className="zip-input"
              placeholder="Enter ZIP Code"
            /> */}
          </div>
        </section>
      )}

      {showForm && (
        <div className="donation-form-wrapper" ref={formRef}>
          <span className="back-arrow" onClick={handleToggleForm}>
            ← Back
          </span>
          <DonationForm />
        </div>
      )}
      {/* {eligibility section} */}
      <EligibilitySection />

      {/* donation process section */}
<section className="donation-section" id="donation-process">
  <h2>The Donation Process</h2>
  <p>
    Understanding what happens during a blood donation can help ease any concerns.
    The process is simple, safe, and helps save lives. Follow these steps to know what to expect.
  </p>

  <div className="cards-container">
    <div className="card">
      <h3>Step 1: Registration</h3>
      <p>Fill out your basic information and answer a few health questions to start the process.</p>
      <ul>
        <li>Provide your full name, age, and contact info</li>
        <li>Answer the health eligibility questionnaire</li>
        <li>Consent to donate blood</li>
        <li>Learn about blood donation benefits and safety measures</li>
        <li>Receive your donor ID or registration number</li>
      </ul>
      <p><strong>Tip:</strong> Make sure to bring a valid ID and stay hydrated before arriving.</p>
    </div>

    <div className="card">
      <h3>Step 2: Screening</h3>
      <p>Our trained staff will check your vitals and ensure you are fully eligible to donate blood.</p>
      <ul>
        <li>Temperature, blood pressure, and pulse check</li>
        <li>Hemoglobin level testing</li>
        <li>Medical history and lifestyle review</li>
        <li>Discuss any medications or recent health conditions</li>
        <li>Ask questions about the donation process if needed</li>
      </ul>
      <p><strong>Tip:</strong> Don’t worry if you have minor concerns; our staff will guide you safely.</p>
    </div>

    <div className="card">
      <h3>Step 3: Donation</h3>
      <p>Donate blood safely under professional supervision. Relax and hydrate afterwards.</p>
      <ul>
        <li>Blood is drawn under sterile conditions</li>
        <li>Donation typically takes 8–10 minutes</li>
        <li>Post-donation refreshments and rest area available</li>
        <li>Receive a donation certificate and your health stats</li>
        <li>Learn how your donation will help patients in need</li>
      </ul>
      <p><strong>Tip:</strong> Avoid heavy physical activity for a few hours after donation and drink plenty of fluids.</p>
    </div>
  </div>
</section>




      <Reviews />
      <ContactSection />

    </>
  );
};

export default Hero;
